export default {"src":"/_next/static/media/circlePlus_24.236ff010.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};